
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface CookingSpecialtiesFieldProps {
  specialties: string;
  onSpecialtiesChange: (value: string) => void;
}

export const CookingSpecialtiesField = ({
  specialties,
  onSpecialtiesChange,
}: CookingSpecialtiesFieldProps) => {
  return (
    <div>
      <Label htmlFor="specialties" className="text-black">Cooking Specialties</Label>
      <Textarea
        id="specialties"
        placeholder="Tell us about your cooking expertise and specialties..."
        value={specialties}
        onChange={(e) => onSpecialtiesChange(e.target.value)}
        required
        className="h-32 bg-[#EDEDED] border-gray-200 placeholder:text-[#6B6B6B]"
      />
    </div>
  );
};
